<template>
    <div class="mainContent">
        <!-- 頁首 -->
        <Header :title="title" :isBack="true" />
        <b-container>
            <!-- 標題 -->
            <PwaTitle v-if="false" :textTitle="model.title" :showMore="false"></PwaTitle>
            <div v-if="false" class="global-descript" style="padding-bottom: 20px;">{{ model.descript }}</div>

            <!-- 標題 -->
            <PwaTitle :textTitle="simulation.title" :showMore="false"></PwaTitle>
            <div class="contentBlock shadow-sm ">
                <div class="results-group">
                    <b-row>
                        <b-col>
                            <div class="results-item">
                                <div class="results-itemSubTitle">
                                    {{ simulation.today.title }}
                                </div>
                                <div class="results-itemContent">{{ simulation.today.value }}</div>
                            </div>
                        </b-col>
                        <b-col>
                            <div class="results-item">
                                <div class="results-itemSubTitle">
                                    {{ simulation.crop.title }}
                                </div>
                                <div class="results-itemContent">{{ simulation.crop.value }}</div>
                            </div>
                        </b-col>
                    </b-row>


                </div>
                <div class="results-group">
                    <b-row>
                        <b-col>
                            <!-- 灌溉情境 -->
                            <div class="results-itemTitle">{{ simulation.irrigation.title }}</div>
                            <!-- 預估產量 -->
                            <div class="results-item">
                                <div class="results-itemSubTitle">
                                    {{ simulation.irrigation.volume.title }}
                                </div>
                                <div class="results-itemContent">{{ simulation.irrigation.volume.value }} 公斤/公頃</div>
                            </div>
                            <!-- 未灌溉情境 -->
                            <div class="results-itemTitle">{{ simulation.irrigation_not.title }}</div>
                            <!-- 預估減量 -->
                            <div class="results-item">
                                <div class="results-itemSubTitle">
                                    {{ simulation.irrigation_not.volume.title }}
                                </div>
                                <div class="results-itemContent">{{ simulation.irrigation_not.volume.value }}</div>
                            </div>

                        </b-col>
                        <b-col>
                            <!-- 空白 -->
                            <div class="results-itemTitle">&nbsp;</div>
                            <!-- 預估成熟日(灌溉) -->
                            <div class="results-item">
                                <div class="results-itemSubTitle">
                                    {{ simulation.irrigation.date.title }}
                                </div>
                                <div class="results-itemContent">{{ simulation.irrigation.date.value }}</div>
                            </div>
                            <!-- 空白 -->
                            <div class="results-itemTitle">&nbsp;</div>
                            <!-- 預估成熟日(未灌溉) -->
                            <div class="results-item">
                                <div class="results-itemSubTitle">
                                    {{ simulation.irrigation_not.date.title }}
                                </div>
                                <div class="results-itemContent">{{ simulation.irrigation_not.date.value }}</div>
                            </div>
                        </b-col>
                    </b-row>
                </div>

                <div class="results-group">
                    <b-row>
                        <b-col>
                            <div class="results-item">
                                <!-- 灌溉推薦 -->
                                <div class="results-itemSubTitle">
                                    {{ simulation.recommend.title }}
                                </div>
                                <div class="results-itemContent">{{ simulation.recommend.value }}</div>
                            </div>
                        </b-col>
                        <b-col>
                            <div class="results-item">
                                <!-- 建議灌溉量 -->
                                <div class="results-itemSubTitle">
                                    &nbsp;
                                </div>
                                <div v-if="false" class="results-itemContent">{{ simulation.suggestion.value }}mm</div>
                            </div>
                        </b-col>
                    </b-row>
                </div>

                <!--
                <div class="pt-3">
                    圖表區塊
                </div>
                -->
            </div>

            <!-- 圖表 -->
            <div class="w3-row" style="overflow-x: auto; overflow-y: hidden;" >
                <div id="chart_weather_info_ntu"></div>
                <div id="chart_weather_info_ntu2"></div>
            </div>

            <!-- 表格 -->
            <div class="w3-container" style="margin-top: 15px;">
                <table class="global-table w3-table w3-striped w3-bordered" v-if="simulation.table.length > 0" >
                    <tr class="body" style="background: rgba(121, 85, 72, 0.5);">
                        <td>播種</td>
                        <td>{{ simulation.table[0].date }}</td>
                    </tr>
                    <tr class="body" style="background: rgba(255, 0, 0, 0.5);" v-if="simulation.growth_stage_date > 0 && simulation.table.length > simulation.growth_stage_date">
                        <td>苗芽出土</td>
                        <td>{{ simulation.table[0].date }} 至 {{ simulation.table[simulation.growth_stage_date].date }}</td>
                    </tr>
                    <tr class="body" style="background: rgba(255, 0, 0, 0.5);" v-if="simulation.growth_stage_date > 0 && simulation.table.length <= simulation.growth_stage_date">
                        <td>苗芽出土</td>
                        <td>{{ simulation.table[0].date }} 至 {{ simulation.table[simulation.table.length-1].date }}</td>
                    </tr>

                    <tr class="body" style="background: rgba(255, 192, 0, 0.5);" v-if="simulation.growth_stage_date > 0 && simulation.growth_stage_date2 > 0 && simulation.table.length > simulation.growth_stage_date && simulation.table.length > simulation.growth_stage_date2">
                        <td>苗期</td>
                        <td>{{ simulation.table[simulation.growth_stage_date].date }} 至 {{ simulation.table[simulation.growth_stage_date2].date }}</td>
                    </tr>
                    <tr class="body" style="background: rgba(255, 192, 0, 0.5);" v-if="simulation.growth_stage_date > 0 && simulation.growth_stage_date2 > 0 && simulation.table.length > simulation.growth_stage_date && simulation.table.length <= simulation.growth_stage_date2">
                        <td>苗期</td>
                        <td>{{ simulation.table[simulation.growth_stage_date].date }} 至 {{ simulation.table[simulation.table.length-1].date }}</td>
                    </tr>

                    <tr class="body" style="background: rgba(149, 212, 90, 0.5);" v-if="simulation.growth_stage_date2 > 0 && simulation.growth_stage_date3 > 0 && simulation.table.length > simulation.growth_stage_date2 && simulation.table.length > simulation.growth_stage_date3">
                        <td>開花</td>
                        <td>{{ simulation.table[simulation.growth_stage_date2].date }} 至 {{ simulation.table[simulation.growth_stage_date3].date }}</td>
                    </tr>
                    <tr class="body" style="background: rgba(149, 212, 90, 0.5);" v-if="simulation.growth_stage_date2 > 0 && simulation.growth_stage_date3 > 0 && simulation.table.length > simulation.growth_stage_date2 && simulation.table.length <= simulation.growth_stage_date3">
                        <td>開花</td>
                        <td>{{ simulation.table[simulation.growth_stage_date2].date }} 至 {{ simulation.table[simulation.table.length-1].date }}</td>
                    </tr>

                    <tr class="body" style="background: rgba(0, 173, 78, 0.5);" v-if="simulation.growth_stage_date3 > 0 && simulation.growth_stage_date4 > 0 && simulation.table.length > simulation.growth_stage_date3 && simulation.table.length > simulation.growth_stage_date4">
                        <td>吐絲</td>
                        <td>{{ simulation.table[simulation.growth_stage_date3].date }} 至 {{ simulation.table[simulation.growth_stage_date4].date }}</td>
                    </tr>
                    <tr class="body" style="background: rgba(0, 173, 78, 0.5);" v-if="simulation.growth_stage_date3 > 0 && simulation.growth_stage_date4 > 0 && simulation.table.length > simulation.growth_stage_date3 && simulation.table.length <= simulation.growth_stage_date4">
                        <td>吐絲</td>
                        <td>{{ simulation.table[simulation.growth_stage_date3].date }} 至 {{ simulation.table[simulation.table.length-1].date }}</td>
                    </tr>

                    <tr class="body" style="background: rgba(0, 176, 240, 0.5);" v-if="simulation.growth_stage_date4 > 0 && simulation.growth_stage_date5 > 0 && simulation.table.length > simulation.growth_stage_date4 && simulation.table.length > simulation.growth_stage_date5">
                        <td>充實</td>
                        <td>{{ simulation.table[simulation.growth_stage_date4].date }} 至 {{ simulation.table[simulation.growth_stage_date5].date }}</td>
                    </tr>
                    <tr class="body" style="background: rgba(0, 176, 240, 0.5);" v-if="simulation.growth_stage_date4 > 0 && simulation.growth_stage_date5 > 0 && simulation.table.length > simulation.growth_stage_date4 && simulation.table.length <= simulation.growth_stage_date5">
                        <td>充實</td>
                        <td>{{ simulation.table[simulation.growth_stage_date4].date }} 至 {{ simulation.table[simulation.table.length-1].date }}</td>
                    </tr>
        
                    <tr class="body" style="background: rgba(112, 48, 160, 0.5);" >
                        <td>成熟</td>
                        <td>{{ simulation.table[simulation.growth_stage_date5].date }} 至 {{ simulation.irrigation.date.value }}</td>
                    </tr>

                </table>
            </div>

            <!-- 表格 -->
            <div class="w3-container" style="margin-top: 15px;">
                <table class="global-table w3-table w3-striped w3-bordered" v-if="simulation.table.length > 0" >
                    <tr class="header table-tr">
                        <th>日期</th>
                        <th>降雨量</th>
                        <th>土壤含水量</th>
                        <th>灌溉量</th>
                    </tr>
                    <tr class="body" v-for="(item, index) in simulation.table" :key="index" :class="index % 2 === 0 ? 'table-td-single' : 'table-td-double'">
                        <td>{{ item.date }}</td>
                        <td>{{ item.rain }} mm</td>
                        <td>{{ item.soil }} mm</td>
                        <td>{{ item.irrigation }} mm</td>
                    </tr>
                </table>
            </div>


        </b-container>


    </div>
</template>
<script>
import Header from '@/components/pwa/Header.vue'
import PwaTitle from '@/components/pwa/PwaTitle.vue'
export default {
    created() {
        window.vue = this; 
        if(!window.checkLogin()){ window.setPage("login");}                 
    },  
    components: {
        Header,
        PwaTitle
    },
    data(){
        return {
            title: "作物預期採收模組",
            //DSSAT模型說明
            model:{
                title:"作物預期採收模組說明",
                descript:"本平台協助新湖農場展示DSSAT(Decision Support System for Agrotechnology Transfer)模型模擬結果，DSSAT可根據天氣、土壤、管理等參數預測作物生長週期與產量，並以圖表方式直觀呈現模擬指標..."
            },
            //模擬結果圖表"
            simulation:{
                title:"模擬結果圖表",
                descript:"",
                today:{
                    title:"種植日期",
                    value:""
                },
                crop:{
                    title:"模擬作物",
                    value:"食用玉米"
                },
                //灌溉情境
                irrigation:{
                    title:"灌溉情境",
                    volume:{
                        title:"預估產量",
                        value:"10718"
                    },
                    date:{
                        title:"預估成熟日",
                        value:""
                    }
                },
                irrigation_not:{
                    title:"未灌溉情境",
                    volume:{
                        title:"預估減產",
                        value:""
                    },
                    date:{
                        title:"預估成熟日",
                        value:""
                    }
                },
                recommend:{
                    title:"灌溉推薦",
                    value:"",
                },
                suggestion:{
                    title:"建議灌溉量",
                    value:"0"
                },
                growth_stage_date:0,
                growth_stage_date2:0,
                growth_stage_date3:0,
                growth_stage_date4:0,
                growth_stage_date5:0,
                table:[]
            },

            //api 取得感測值
            apiGetCur: (data) => this.userRequest.get("API/Default/CurlNtuSelect?RecordDate=2025-08-10", data),

        }
    },
    mounted(){

        //this.test();
        this.getData();
    },
    methods: {
        goHome:function(){ window.setPage("home"); },
        getData() {

            this.apiGetCur()
            .then((res) => {

                const json = JSON.parse(res.data);
                this.simulation.today.value = json.date;
                this.simulation.irrigation.date.value = json.irrigation_date;
                this.simulation.irrigation.volume.value = json.yield;
                this.simulation.irrigation_not.date.value = json.irrigation_not_date;
                this.simulation.irrigation_not.volume.value = json.yield_risk;

                this.simulation.recommend.value = json.irrigation_recommendation;
                this.simulation.suggestion.value = json.irrigation;

                this.simulation.growth_stage_date = json.growth_stage_date;
                this.simulation.growth_stage_date2 = json.growth_stage_date2;
                this.simulation.growth_stage_date3 = json.growth_stage_date3;
                this.simulation.growth_stage_date4 = json.growth_stage_date4;
                this.simulation.growth_stage_date5 = json.growth_stage_date5;
                this.simulation.table = json.table;

                var option = {};
                option.date = [];
                option.rain = [];
                option.soil = [];
                option.irrigation = [];
                for (let i = 0; i < json.table.length; i++) 
                {
                    option.date.push(json.table[i].date); 
                    option.rain.push(json.table[i].rain); 
                    option.soil.push(json.table[i].soil); 
                    option.irrigation.push(json.table[i].irrigation); 
                }

                option.growth_stage_date = json.growth_stage_date;
                option.growth_stage_date2 = json.growth_stage_date2;
                option.growth_stage_date3 = json.growth_stage_date3;
                option.growth_stage_date4 = json.growth_stage_date4;
                option.growth_stage_date5 = json.growth_stage_date5;

                option.irrigation_date = json.irrigation_date;

                window.ChartWeatherInfoNtu = null;
                window.ChartWeatherInfoNtu2 = null;

                window.ThreadTool.Delay(function(){
                    
                    window.setChartWeatherInfoNtu("#chart_weather_info_ntu","#chart_weather_info_ntu2",option);

                },this.delay_ms_chart); 
                    console.log(json);

                })
                .catch((err) => {
                    console.log(err);
                });          
        },
        test:function(){

            var json = {

                //當天日期
                date:"2025-09-01",
                //收成日期
                irrigation_date:"2025-10-19",
                //未灌溉收成日期
                irrigation_not_date:"2025-10-19",
                //產量
                yield:"7737",
                //減產風險
                yield_risk:"56%",
                //土壤入滲量
                infiltration:"0",
                //蒸散量
                evapotranspiration:"6.4",
                //土壤剖面含水量
                soil_moisture:"206",
                //灌溉推薦
                irrigation_recommendation:"建議灌溉",
                //灌溉量
                irrigation:"0",
                //生育階段日期
                growth_stage_date:6,
                growth_stage_date2:15,
                growth_stage_date3:20,
                growth_stage_date4:45,
                growth_stage_date5:53,
                table : [
                    { date: '2025-08-02', rain: 250, soil: 222, irrigation: 0 },
                    { date: '2025-08-03', rain: 100, soil: 222, irrigation: 0 },
                    { date: '2025-08-04', rain: 300, soil: 221, irrigation: 0 },
                    { date: '2025-08-05', rain: 100, soil: 221, irrigation: 0 },
                    { date: '2025-08-06', rain: 120, soil: 221, irrigation: 0 },
                    { date: '2025-08-07', rain: 150, soil: 220, irrigation: 0 },
                    { date: '2025-08-08', rain: 0,   soil: 220, irrigation: 0 },
                    { date: '2025-08-09', rain: 0,   soil: 220, irrigation: 0 },
                    { date: '2025-08-10', rain: 0,   soil: 221, irrigation: 0 },
                    { date: '2025-08-11', rain: 0,   soil: 221, irrigation: 0 },
                    { date: '2025-08-12', rain: 0,   soil: 220, irrigation: 0 },
                    { date: '2025-08-13', rain: 0,   soil: 219, irrigation: 0 },
                    { date: '2025-08-14', rain: 0,   soil: 218, irrigation: 0 },
                    { date: '2025-08-15', rain: 0,   soil: 220, irrigation: 0 },
                    { date: '2025-08-16', rain: 0,   soil: 264, irrigation: 0 },
                    { date: '2025-08-17', rain: 0,   soil: 256, irrigation: 0 },
                    { date: '2025-08-18', rain: 0,   soil: 247, irrigation: 0 },
                    { date: '2025-08-19', rain: 0,   soil: 238, irrigation: 0 },
                    { date: '2025-08-20', rain: 0,   soil: 239, irrigation: 0 },
                    { date: '2025-08-21', rain: 0,   soil: 247, irrigation: 0 },
                    { date: '2025-08-22', rain: 0,   soil: 240, irrigation: 0 },
                    { date: '2025-08-23', rain: 0,   soil: 222, irrigation: 0 },
                    { date: '2025-08-24', rain: 0,   soil: 215, irrigation: 0 },
                    { date: '2025-08-25', rain: 16,  soil: 210, irrigation: 16 },
                    { date: '2025-08-26', rain: 0,   soil: 219, irrigation: 0 },
                    { date: '2025-08-27', rain: 0,   soil: 213, irrigation: 0 },
                    { date: '2025-08-28', rain: 0,   soil: 208, irrigation: 0 },
                    { date: '2025-08-29', rain: 16,  soil: 203, irrigation: 16 },
                    { date: '2025-08-30', rain: 0,   soil: 217, irrigation: 0 },
                    { date: '2025-08-31', rain: 0,   soil: 212, irrigation: 0 },
                    { date: '2025-09-01', rain: 0,   soil: 206, irrigation: 0 }
                ]

            }

            this.simulation.today.value = json.date;
            this.simulation.irrigation.date.value = json.irrigation_date;
            this.simulation.irrigation.volume.value = json.yield;
            this.simulation.irrigation_not.date.value = json.irrigation_not_date;
            this.simulation.irrigation_not.volume.value = json.yield_risk;

            this.simulation.recommend.value = json.irrigation_recommendation;
            this.simulation.suggestion.value = json.irrigation;

            this.simulation.growth_stage_date = json.growth_stage_date;
            this.simulation.growth_stage_date2 = json.growth_stage_date2;
            this.simulation.growth_stage_date3 = json.growth_stage_date3;
            this.simulation.growth_stage_date4 = json.growth_stage_date4;
            this.simulation.growth_stage_date5 = json.growth_stage_date5;
            this.simulation.table = json.table;

            var option = {};
            option.date = [];
            option.rain = [];
            option.soil = [];
            option.irrigation = [];
            for (let i = 0; i < json.table.length; i++) 
            {
                option.date.push(json.table[i].date); 
                option.rain.push(json.table[i].rain); 
                option.soil.push(json.table[i].soil); 
                option.irrigation.push(json.table[i].irrigation); 
            }

            option.growth_stage_date = json.growth_stage_date;
            option.growth_stage_date2 = json.growth_stage_date2;
            option.growth_stage_date3 = json.growth_stage_date3;
            option.growth_stage_date4 = json.growth_stage_date4;
            option.growth_stage_date5 = json.growth_stage_date5;

            window.ChartWeatherInfoNtu = null;
            window.ChartWeatherInfoNtu2 = null;

            window.ThreadTool.Delay(function(){
                
                window.setChartWeatherInfoNtu("#chart_weather_info_ntu","#chart_weather_info_ntu2",option);

            },this.delay_ms_chart); 

        }
    }
}
</script>
<style>

    #map {
        width: 100%;
        height: 100vh;
        min-height: 70vh;
        background: #FFFFFF;
    }

    .table-tr {

        background: #1D976C;
        color: #FFFFFF;
    }

    .table-td-single {

        background: #ecfff8;
        color: #000000;
    } 

    .table-td-double {

        background: #99D0BC;
        color: #000000;
    }

</style>